require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./recruiting-and-retaining-female-deputies.json") })
        }
      }, "path---recruiting-and-retaining-female-deputies");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---recruiting-and-retaining-female-deputies!./.cache/json/recruiting-and-retaining-female-deputies.json
// module id = 966
// module chunks = 231608221292675